/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
// NOTE: a replacement for drei's useAnimations hook 
// that doesn't call update w/ delta via useFrame
import { useEffect, useState, useRef } from 'react';
import { AnimationMixer } from 'three';

// NOTE: override for AnimationMixer's update method
// the mixer's update looked for active actions and bindings
// in private state (that were not active because we're not
// playing the animation)
const update = function(deltaTime) {
  // advance the time and update apply the animation
  deltaTime *= this.timeScale;

  const actions = this._actions;
  const time = this.time = deltaTime;
  const timeDirection = Math.sign(deltaTime);
  const accuIndex = this._accuIndex ^= 1;

  // run active actions
  for (let i = 0; i !== actions.length; ++i) {
    const action = actions[i];
    action._update(time, deltaTime, timeDirection, accuIndex);
  }

  // update scene graph
  const bindings = this._bindings;
  for (let i = 0; i !== bindings.length; ++i) {
    bindings[i].apply(accuIndex);
  }

  return this;
};

export default function useManagedAnimations(clips, ref) {
  const [mixer] = useState(() => {
    const mixer = new AnimationMixer(undefined);
    mixer.update = update;
    return mixer;
  });
  const lazyActions = useRef({});
  const [api] = useState(() => {
    const actions = {};

    clips.forEach(clip => {
      return Object.defineProperty(actions, clip.name, {
        enumerable: true,

        get() {
          if (!ref.current) return;
          return (
            lazyActions.current[clip.name] || 
            (lazyActions.current[clip.name] = mixer.clipAction(clip.clone(), ref.current))
          );
        },
      });
    });

    return {
      ref,
      clips,
      actions,
      names: clips.map(c => c.name),
      mixer,
    };
  });
  
  useEffect(() => {
    const currentRoot = ref.current;
    return () => {
      // Clean up only when clips change, wipe out lazy actions and uncache clips
      lazyActions.current = {};
      Object.values(api.actions).forEach(action => {
        if (currentRoot) {
          mixer.uncacheAction(action, currentRoot);
        }
      });
    };
  }, [clips]);

  return api;
};

useManagedAnimations.update = update;